import * as ngCore from '@angular/core'
import * as ds from '@attain-apps/fe/web/main/lib/design'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import * as state from '../../../../../../../../state'
import * as modals from '../../../modals'

/**
 * Space organization component for presenting organization assignments in
 * record details
 */
@ngCore.Component({
  imports: [
    ds.layout.widget.Component,
    ds.table.Component,
    ds.overlay.confirmation.Component,
    modals.organizationAssignment.Component,
  ],
  selector: 'atn-space-organization-assignments',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** When true, the component is in read-only mode (e.g. room signed off). */
  public readonly isReadonlySg = ngCore.input(false, { alias: 'readonly' })

  // TODO: Make an input for recordAssignedOrgsEc to allow reuse between
  // full and lite space
  /** @see {@link state.space.lite.recordAssignedOrgs.Collection} */
  public readonly recordAssignedOrgsEc = ngCore.inject(
    state.space.lite.recordAssignedOrgs.Collection,
  )

  /** Canonical table input for lite organization assignments. */
  public readonly tableConfig = ngCore.computed(
    (isReadonly = this.isReadonlySg()) =>
      ({
        collection: this.recordAssignedOrgsEc,
        view: {
          showColumnSettings: false,
          title: 'Organization Assignments',
          // A pencil rather than the usual (+), since assigning an
          // organization again is also how its occupier status is changed
          toolbarTools: isReadonly
            ? []
            : [
                {
                  iconClass: 'atn-icon atn-edit atn-blue',
                  id: 'edit',
                  onClick: this.editClickHandler,
                  title: 'Edit',
                },
              ],
        },
      }) satisfies ds.table.ec.Config.Input<state.space.lite.recordAssignedOrgs.TypeParams>,
  )

  /** Opens the organization assignment modal */
  public readonly editClickHandler = () => {
    this.recordAssignedOrgsEc.plugins.editingPlugin.feature.actions.edit
      .from('OrgAssignments.Toolbar.Edit.Clicked')
      .dispatch({
        id: ec.plugins.standard.editing.models.CreationId.generate(),
      })
  }

  /**
   * Handles the confirmation action for organization assignment deletion.
   */
  public confirmDeletionClickHandler(): void {
    this.recordAssignedOrgsEc.plugins.editingPlugin.feature.actions.submit
      .from('OrgAssignment.Delete.Confirmation.Footer.Buttons.Confirm.Clicked')
      .dispatch({ delete: true })
  }

  /**
   * Handles the cancellation action for organization assignment deletion.
   */
  public cancelDeletionClickHandler(): void {
    this.recordAssignedOrgsEc.plugins.editingPlugin.feature.actions.discard
      .from('OrgAssignment.Delete.Confirmation.Footer.Buttons.Cancel.Clicked')
      .dispatch({ delete: true })
  }
}
